import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";

export default function View({ uuid }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ data, setData ] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([
      getData(),
    ])
    setReady(true);
  }

  async function getData() {
    await callApi('get-gallery-data', { uuid }).then((response) => {
      if(response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    })
  }

  useEffect(() => {
    init();
  }, []);

  if (ready && data) {
    return (
      <div className="container mt-4 mb-5">

        <div className="row justify-content-center">

          <div className="col-lg-10 col-xl-9">

            {/* Meta */}
            <div className="d-flex justify-content-end mb-2">
              <span
                className="text-muted font-light"
                style={{ fontSize: "14px" }}
              >
                {formatDate(data.dateCreated)}
              </span>
            </div>

            {/* Image Card */}
            <div
              className="mb-4"
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 12px 35px rgba(0,0,0,0.12)",
                backgroundColor: "#f8f9fa"
              }}
            >
              <img
                src={CDN_URL + data.photo}
                alt=""
                style={{
                  width: "100%",
                  display: "block",
                  objectFit: "cover",
                  maxHeight: "75vh"
                }}
              />
            </div>

            {/* Description */}
            <div className="mt-3">
              <h6
                style={{
                  fontSize: "22px",
                  lineHeight: "1.7",
                  color: "#333"
                }}
                className="font-semi-bold"
              >
                {data.description}
              </h6>
            </div>

          </div>

        </div>

      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
